import * as React from "react";
import { useHistory } from "react-router-dom";
import Layout from "./Layout";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Link from "../misc/Link";
import ChangePasswordForm from "./ChangePasswordForm";

const useStyles = makeStyles((theme) => ({
  signIn: { display: "flex" },
  signInText: { marginRight: theme.spacing(0.5) },
}));

export default function ChangePassword({ onSubmit, error }) {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Layout title="Change Password">
      <ChangePasswordForm onSubmit={onSubmit} error={error} />
      <div className={classes.signIn}>
        <span className={classes.signInText}>
          Don't need to change your password?
        </span>
        <Link
          href="#"
          onClick={(e) => {
            e.preventDefault();
            history.push("/login");
          }}
        >
          Sign in
        </Link>
      </div>
    </Layout>
  );
}
